import api from "./api";

const contactApi = {
    async create(contactData) {
        const response = await api.post('/contacts', contactData);
        return response.data;
    },
    async getAll() {
        const response = await api.get('/contacts');
        return response.data;
    },
    
    async delete(id) {
        const response = await api.delete(`/contacts/${id}`);
        return response.data;
    }
    ,
    async getById(id) {
        const response = await api.get(`/contacts/${id}`);
        return response.data;
    },
    async update(id, contactData) {
        const response = await api.put(`/contacts/${id}`, contactData);
        return response.data;
    }
};


export default contactApi;